import client from 'sanity-client';

import { EduHubArticleResult } from 'types/studio/eduHub';
import { LocaleEnum } from 'schema/locale';

import { ARTICLES_BY_PAGE } from './constants';

const sanityQuery = `
*[_type == "eduArticles" && language == $locale && slug.current != $featuredArticleSlug && dateTime(date) <= dateTime(now()) && select(
    $categorySlug != "" => category->slug.current == $categorySlug,
    $tagSlug != "" => tags[]->slug.current match $tagSlug,
    $categorySlug == "" => category->slug.current match "*",
  )] | order(date desc) [$startWith...$endWith] {
    ...,
    category ->
  }
`;

type LoadArticles = {
  categorySlug?: string;
  startWith?: number;
  endWith?: number;
  locale: LocaleEnum;
  featuredArticle?: EduHubArticleResult;
  tagSlug?: string;
};

export async function loadEduHubArticles({
  categorySlug = '',
  startWith = 0,
  endWith = ARTICLES_BY_PAGE,
  locale,
  featuredArticle,
  tagSlug = ''
}: LoadArticles): Promise<EduHubArticleResult[]> {
  const featuredArticleSlug = featuredArticle?.slug?.current || '';

  const articlesData: EduHubArticleResult[] = await client.fetch(sanityQuery, {
    categorySlug,
    startWith,
    endWith,
    locale,
    featuredArticleSlug,
    tagSlug
  });

  if (!articlesData) {
    throw new Error('404 error, no articles found');
  }

  return articlesData;
}

type LoadArticlesCount = {
  categorySlug?: string;
  locale: LocaleEnum;
  featuredArticleSlug?: string;
  tagSlug?: string;
};

export async function loadArticlesCount({
  locale,
  featuredArticleSlug,
  categorySlug = '',
  tagSlug = ''
}: LoadArticlesCount) {
  const result = await client.fetch(
    `{
      "total": count(*[_type == "eduArticles" && language == $locale && slug.current != $featuredArticleSlug && dateTime(date) <= dateTime(now()) && select(
        $categorySlug != "" => category->slug.current == $categorySlug,
        $tagSlug != "" => tags[]->slug.current match $tagSlug,
        $categorySlug == "" => category->slug.current match "*",
      )])
    }`,
    { categorySlug, locale, featuredArticleSlug, tagSlug }
  );

  return result?.total ?? ARTICLES_BY_PAGE;
}
